// Angular imports
import { Component, OnInit, OnDestroy } from '@angular/core';

// RxJs imports
import { Subscription } from 'rxjs';

// 3rd party imports
import postscribe from 'postscribe';

//Service imports
import { EnvironmentConfigService } from '../../_services/environment-config.service';
import { ScreenService } from '../../_services/shared-services/screen.service';
import { UserService } from '../../_services/data-services/user.service';

// Model imports
import { UserPropertyResultDto } from '../../_models/user-property-result-dto';

// Constants imports
import { Constants } from '../../_constants/constants';

// CC-Common imports
import { RxjsUtils } from '@therealmanage/ciranet-ui-common';

@Component({
  selector: 'app-cira-chat',
  templateUrl: './cira-chat.component.html',
  styleUrls: ['./cira-chat.component.scss'],
  standalone: false
})
export class CiraChatComponent implements OnInit, OnDestroy {
  isSmallScreen: boolean = true;
  isScriptExecuted: boolean = false;
  chatIconTimer: any;
  resizeTimer: any;
  selectedProperty: UserPropertyResultDto = null;
  propertyChangeSubscription: Subscription;

  constructor(
    private screenService: ScreenService,
    private userService: UserService,
    private envConfig: EnvironmentConfigService
  ) {}

  ngOnInit() {
    this.propertyChangeSubscription = RxjsUtils.subscribeToSubject(
      this.userService.getSubjectPropertySelectionChanged(),
      () => {
        const selectedProperty = this.userService.getSelectedProperty();
        if (!!selectedProperty && !!selectedProperty.communityId) {
          if (
            !this.selectedProperty ||
            this.selectedProperty.communityId !== selectedProperty.communityId
          ) {
            this.selectedProperty = selectedProperty;
            this.loadCCChatButton();
          }
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (!!this.propertyChangeSubscription) {
      this.propertyChangeSubscription.unsubscribe();
    }
  }

  private loadCCChatButton(): void {
    this.isSmallScreen = this.screenService.isSmallScreen();
    if (postscribe && !this.isSmallScreen && !this.isScriptExecuted) {
      this.isScriptExecuted = true;
      let chatButtonScript = this.envConfig.ccChatButtonScript;
      let chatDepartment = Constants.defaultCiraChatDepartment;
      let userParameter = '';
      const userInfo = this.userService.getCurrentUserInfo();

      if (userInfo !== null) {
        if (userInfo.displayName !== null) {
          userParameter =
            '&ChatUser=' + userInfo.displayName.replace(/'/g, "\\'");
        } else {
          userParameter = '&ChatUser=' + userInfo.userId.replace(/'/g, "\\'");
        }
      }

      if (!!this.selectedProperty) {
        if (
          this.selectedProperty.managementCompanyId &&
          this.selectedProperty.managementCompanyId !== 1 &&
          this.selectedProperty.managementCompanyId !== 18
        ) {
          chatDepartment = 'CC Customer Support';
        }
      }

      chatButtonScript = chatButtonScript.replace('{0}', chatDepartment);
      chatButtonScript = chatButtonScript.replace('{1}', userParameter);
      clearTimeout(this.chatIconTimer);

      if (!!document.getElementById('chatIconContainer')) {
        document.getElementById('chatIconContainer').innerHTML = '';
      }

      this.chatIconTimer = setTimeout(() => {
        document.getElementById('chatIconContainer').innerHTML = '';
        postscribe('#chatIconContainer', chatButtonScript);
      }, 500);
    }
  }
}
